function setStickyOffset() {
  var header =
    document.querySelector('header.header') ||
    document.querySelector('[data-header]') ||
    document.querySelector('.site-header') ||
    document.querySelector('header');

  var extra = 16; // lille luft
  var offset = header ? header.getBoundingClientRect().height + extra : 80;
  document.documentElement.style.setProperty('--sticky-offset', offset + 'px');
}

document.addEventListener('DOMContentLoaded', setStickyOffset);
window.addEventListener('resize', setStickyOffset);
